export default __webpack_public_path__ + "static/media/wi-hot.1fbcc3a2.svg";